import { createRoot } from "react-dom/client";
import WinnersTemplate from "@/app/(custom-header)/winners/[...slug]/page";
import { StoreProvider } from "@/app/storeProvider";
import React from "react";

const root = createRoot(document.getElementById("react-winners") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <WinnersTemplate />
    </StoreProvider>
  </React.StrictMode>
);
